import { Merchant, MerchantLocation } from '../../api/types';

export interface ConflictField {
  field: string;
  incoming: unknown;
  existing: unknown;
}

const norm = (value: string | undefined | null): string =>
  (value ?? '').trim().toLowerCase();

export const detectMerchantConflicts = (
  incoming: { entityLegalName: string; tin: string },
  existing: Merchant,
): ConflictField[] => {
  const conflicts: ConflictField[] = [];
  if (
    existing.legalName != null &&
    norm(existing.legalName) !== norm(incoming.entityLegalName) &&
    norm(existing.name) !== norm(incoming.entityLegalName)
  ) {
    conflicts.push({
      field: 'name',
      incoming: incoming.entityLegalName,
      existing: existing.legalName ?? existing.name,
    });
  }
  if (existing.tin != null && norm(existing.tin) !== norm(incoming.tin)) {
    conflicts.push({
      field: 'tin',
      incoming: incoming.tin,
      existing: existing.tin,
    });
  }
  return conflicts;
};

export const detectMerchantLocationConflicts = (
  incoming: { city: string; address: string },
  existing: MerchantLocation,
): ConflictField[] => {
  const conflicts: ConflictField[] = [];
  if (existing.terminatedAt != null) {
    conflicts.push({
      field: 'terminatedAt',
      incoming: null,
      existing: existing.terminatedAt,
    });
  }
  // Address comparison is intentionally loose: provider rosters often vary in
  // formatting (suite numbers, abbreviations). We surface the existing address
  // for human review rather than auto-flagging mismatches.
  return conflicts;
};
